import { signedViewResourceKey } from '@/utils/imageDisplayAccess';

/** 已成功加载过的 signed view / 直链，再次展示时跳过队列与占位等待 */
const loadedViewUrls = new Set();
const loadedResourceKeys = new Set();

export function markManagedViewImageLoaded(url) {
  const key = String(url || '').trim();
  if (key) loadedViewUrls.add(key);
  const resourceKey = signedViewResourceKey(key);
  if (resourceKey) loadedResourceKeys.add(resourceKey);
}

export function isManagedViewImageLoaded(url) {
  const key = String(url || '').trim();
  if (loadedViewUrls.has(key)) return true;
  const resourceKey = signedViewResourceKey(key);
  return resourceKey ? loadedResourceKeys.has(resourceKey) : false;
}

/** 同路径覆盖 / invalidate 后清除「已加载」标记，避免懒加载复用旧图 */
export function unmarkManagedViewImageLoaded(url) {
  const key = String(url || '').trim();
  if (key) loadedViewUrls.delete(key);
  const resourceKey = signedViewResourceKey(key);
  if (!resourceKey) return;
  loadedResourceKeys.delete(resourceKey);
  for (const u of [...loadedViewUrls]) {
    if (signedViewResourceKey(u) === resourceKey) loadedViewUrls.delete(u);
  }
}

export function clearManagedViewImageLoadCache() {
  loadedViewUrls.clear();
  loadedResourceKeys.clear();
}
